export const notificationsEndpointConfig = {
  baseUrl: "api/v1/notifications",
  platform: (): string => `${notificationsEndpointConfig.baseUrl}/platform`,
  unread: (): string =>
    `${notificationsEndpointConfig.baseUrl}/platform/count/unread`,
  markRead: (): string =>
    `${notificationsEndpointConfig.baseUrl}/platform/mark-read`,
  userPreferences: (): string =>
    `${notificationsEndpointConfig.baseUrl}/user-preferences`,
};
